import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined';
// import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';

import { DrawCompteEntrepriseIcons, DrawHomeIcon } from '../../../data/SVGs';
const navbarListEsn = [
    {
        icon: DrawHomeIcon,
        desc: 'Tableau de bord TODOOOOOOOOO',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'dashbordClient'
    },
    {
        icon: PersonOutlineOutlinedIcon,
        desc: 'Mon Compte',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Profil personnel',
                badge: 0,
                link: 'profile'
            },
            {
                desc: 'Paramètres de compte',
                badge: 0,
                link: 'parametreCompte'
            },
        ],
    },
    {
        icon: AssignmentIndOutlinedIcon,
        desc: 'Gestion des Experts',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'gestionExperts'
    },
    {
        icon: DrawCompteEntrepriseIcons,
        desc: 'Compte d\'entreprise',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Profil entreprise',
                badge: 0,
                link: 'donneesGenerales'
            },

            {
                desc: 'Documents administratifs',
                badge: 0,
                link: 'docAdministrative'
            },

            {
                desc: 'Documents commerciaux',
                badge: 0,
                link: 'docCommerciaux'
            },
            {
                desc: 'Collaborateurs d\'entreprise',
                badge: 0,
                link: 'collaborators'
            },
        ],
    },
    {
        icon: WorkOutlineOutlinedIcon,
        desc: 'Mes AO',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Créer un AO',
                badge: 0,
                link: 'createAO'
            },
            {
                desc: 'AO et candidatures',
                badge: 0,
                link: 'aos'
            },
            {
                desc: 'Les drafts',//'Drafts',
                badge: 0,
                link: 'drafts'
            },
        ],
    },

    {
        icon: WorkOutlineOutlinedIcon,
        desc: 'AO-HTH ',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Rechercher un AO',
                badge: 0,
                link: 'aosHTH'
            },
            {
                desc: 'Mes candidatures',
                badge: 0,
                link: 'candidatures'
            },
            {
                desc: 'Mes favoris',
                badge: 0,
                link: 'aosFavoris'
            },
            //{
            //    desc: 'Mes alertes',
            //    badge: 0,
            //    link: 'alertes'
            //},
        ],
    },

    {
        icon: InsertInvitationOutlinedIcon,
        desc: 'Mes RDV',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'gestionRDV'
    },

    {
        icon: PersonSearchOutlinedIcon,
        desc: 'CVthèque',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Trouver des CV',
                badge: 0,
                link: 'cvTheque',
            },
            {
                desc: 'Mes dossiers',
                badge: 0,
                link: 'AllMyDossier'
            },
        ],
    },
    // {
    //     icon: AssignmentOutlinedIcon,
    //     desc: 'Missions et BDC',
    //     secondDesc: '',
    //     badge: 0,
    //     subList: [
    //         {
    //             desc: 'Propositions commerciales',
    //             badge: 0,
    //             link: 'propositionCommercial'
    //         },
    //         {
    //             desc: 'Les missions & Bons de commande',
    //             badge: 0,
    //             link: 'mission'
    //         },
    //     ],
    // },
    {
        icon: AssignmentOutlinedIcon,
        desc: 'Gestion des missions-HTH',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Vente (ESN=Expert)',
                badge: 1,
                secondDesc: '',
                subList: [
                    {
                        desc: 'Ordres de mission',
                        badge: 2,
                        link: 'ordreMission'
                    },
                    {
                        desc: 'Missions et BDC',
                        badge: 2,
                        link: 'missionVente'
                    },
                    {
                        desc: 'CRA',
                        badge: 2,
                        link: 'AllCrasVente'
                    },
                    {
                        desc: 'Facturation',
                        badge: 2,
                        link: 'AllFacturesVente'
                    }
                ]
            },
            {
                desc: 'Achat (ESN=Client)',
                badge: 1,
                secondDesc: '',
                subList: [
                    {
                        desc: 'Propositions commerciales',
                        badge: 0,
                        link: 'propositionCommercial'
                    },
                    {
                        desc: 'Missions et BDC',
                        badge: 0,
                        link: 'mission'
                    },
                    {
                        desc: 'CRA',
                        badge: 0,
                        link: 'AllCras'
                    },
                    {
                        desc: 'Facturation',
                        badge: 0,
                        link: 'AllFactures'
                    }
                ]
            },
        ],
    },

    // {
    //     icon: InventoryOutlinedIcon,
    //     desc: 'CRA & Factures',
    //     secondDesc: '',
    //     badge: 0,
    //     subList: [
    //         {
    //             desc: 'Compte rendu d\'activité',
    //             badge: 0,
    //             link: 'AllCras'
    //         },
    //         {
    //             desc: 'Factures',
    //             badge: 0,
    //             link: 'AllFactures'
    //         },
    //     ],
    // },
    //hide #v2
    //{
    //    icon: DrawOutilSuiviIcons,
    //    desc: 'Outil suivi',
    //    secondDesc: '',
    //    badge: 0,
    //    subList: [
    //        /**
    //   *     <Route path="Accueil" element={<Accueil />} />
    //              <Route path="Dashboard" element={<Dashboard />} />
    //              <Route path="Tasks" element={<Tasks />} />
    //              <Route path="Ressources" element={<Ressources />} />
    //              <Route path="Notifications" element={<Notifications />} />
    //              <Route path="Collaborators" element=
    //   */
    //        {
    //            desc: 'Suivi mission',
    //            badge: 0,
    //            // Must be fixed
    //            link: 'suiviMission'
    //        },
    //        {
    //            desc: 'Accueil',
    //            badge: 0,
    //            // Must be fixed
    //            link: 'suiviMission/Accueil'
    //        },
    //        {
    //            desc: 'Tasks',
    //            badge: 0,
    //            // Must be fixed
    //            link: 'suiviMission/Tasks'
    //        },
    //        {
    //            desc: 'Ressources',
    //            badge: 0,
    //            // Must be fixed
    //            link: 'suiviMission/Ressources'
    //        },
    //        {
    //            desc: 'Notifications',
    //            badge: 0,
    //            // Must be fixed
    //            link: 'suiviMission/Notifications'
    //        },
    //        {
    //            desc: 'Collaborateurs',
    //            badge: 0,
    //            // Must be fixed
    //            link: 'suiviMission/CollaboratorsSuiviMission'
    //        },
    //    ],
    //},
];

// export const navbarListHome = [
//     {
//         icon: DrawHomeIcon,
//         desc: 'Clients',
//         secondDesc: '',
//         badge: 0,
//         subList: [],
//         link: 'homeClient'
//     },
//     {
//         icon: DrawHomeIcon,
//         desc: 'ESN',
//         secondDesc: '',
//         badge: 0,
//         subList: [],
//         link: 'homeESN'
//     },
//     {
//         icon: DrawHomeIcon,
//         desc: 'Experts',
//         secondDesc: '',
//         badge: 0,
//         subList: [],
//         link: 'homeExpert'
//     },
//     {
//         icon: PersonOutlineOutlinedIcon,
//         desc: 'A propos',
//         secondDesc: '',
//         badge: 0,
//         subList: [
//             {
//                 desc: 'HTH',
//                 badge: 0,
//                 link: 'HTH'
//             },
//             {
//                 desc: 'Pourquoi HTH',
//                 badge: 0,
//                 link: 'whyHtH'
//             },
//             {
//                 desc: 'Nos formules',
//                 badge: 10,
//                 link: 'pricing'
//             },
//             {
//                 desc: 'Blog',
//                 badge: 11,
//                 link: 'blogs'
//             },
//         ],
//     },
// ];

export default navbarListEsn;
